var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Stack } from '../Layout';
import { useDialogStyles } from './DialogStylingContext';
import { styled } from '@mui/material/styles';
var StyledStack = styled(Stack)(function () {
    var _a = useDialogStyles().padding, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight;
    return {
        flex: '0 0 auto',
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        paddingTop: '16px',
    };
});
var DialogActions = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'row' : _b, _c = _a.justifyContent, justifyContent = _c === void 0 ? 'flex-end' : _c, _d = _a.spacing, spacing = _d === void 0 ? 1 : _d, pt = _a.pt, paddingTop = _a.paddingTop, props = __rest(_a, ["direction", "justifyContent", "spacing", "pt", "paddingTop"]);
    return (React.createElement(StyledStack, __assign({ justifyContent: justifyContent, spacing: spacing, direction: direction }, props)));
};
export default DialogActions;
//# sourceMappingURL=DialogActions.js.map